/**
 * Put RGB into a string
 */
export default function rgbStringfy(r, g, b) {
    return "rgb(" + r + ", " + g + ", " + b + ")";
}
//# sourceMappingURL=rgbStringfy.js.map